import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagosComponent } from './pagos/pagos.component';
import { ViewFEComponent } from './view-fe/view-fe.component';
import { SincronizacionSIIGOComponent } from './sincronizacion-siigo/sincronizacion-siigo.component';

const routes: Routes = [
  {
    path: '', children: [
      { path: 'pagos_servicio', component: PagosComponent },
      { path: 'FE/:idVenta', component: ViewFEComponent },
      { path: 'sincronizar-SIIGO', component: SincronizacionSIIGOComponent },
    ]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntegrationRoutingModule { }
